import { PrenotazioneStepperActions } from '@redturtle/volto-io-prenoto/components/View/PrenotazioneView';
import { SelectInput } from 'design-comuni-plone-theme/components';
import {
  RichTextSection,
  SideMenu,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { Card, TextArea, Input } from 'design-react-kit';
import React, { createRef, useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import {
  changeBookingField,
  getBookableTypesOptions,
} from '@redturtle/volto-io-prenoto/helpers/prenotazione';
import {
  RichText,
  richTextHasContent,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { useHistory, useLocation } from 'react-router-dom';

const messages = defineMessages({
  motivation_title: {
    id: 'booking_motivation_title',
    defaultMessage: 'Motivo',
  },
  motivation_description: {
    id: 'booking_motivation_description',
    defaultMessage: 'Scegli il motivo dell’appuntamento',
  },
  details_title: {
    id: 'booking_details_title',
    defaultMessage: 'Dettagli',
  },
  details_description: {
    id: 'booking_details_description',
    defaultMessage: 'Aggiungi ulteriori dettagli',
  },
  type_select_label: {
    id: 'booking_type_select_label',
    defaultMessage: 'Seleziona opzione',
  },
  details_info_text: {
    id: 'booking_details_info_text',
    defaultMessage: 'Inserire massimo 200 caratteri',
  },
});

const PrenotazioneDettagli = ({
  prenotazioneObj,
  setPrenotazioneObj,
  activeStep,
  setActiveStep,
  scrollToTop,
  params,
}) => {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  // prenotazione schema
  const bookingSchemaResult = useSelector(
    (state) => state.bookingSchema?.result,
  );
  const schema = bookingSchemaResult?.fields || [];
  const bookableTypes = bookingSchemaResult?.booking_types?.bookable || [];
  // const unbookable = bookingSchemaResult?.booking_types?.unbookable || [];

  // SIDEMENU
  const documentBody = createRef();
  const [sideMenuElements, setSideMenuElements] = useState(null);

  const currentBookingType = useMemo(() => {
    return bookableTypes.find(
      (el) => el.name === prenotazioneObj.booking_type?.value,
    );
  }, [bookableTypes, prenotazioneObj.booking_type]);

  useEffect(() => {
    if (documentBody.current) {
      if (__CLIENT__) {
        setSideMenuElements(documentBody.current);
      }
    }
  }, [documentBody]);

  /* Set booking_type select from url params, schema and default values */
  useEffect(() => {
    let booking_type = null;
    let default_fields = [...(prenotazioneObj.booking_fields ?? [])];
    if (default_fields.length == 0) {
      schema.forEach((f) => {
        if (f.value?.length > 0) {
          default_fields.push({ name: f.name, value: f.value });
        }
      });
    }

    if (params.booking_type) {
      for (let el of bookableTypes) {
        if (
          el.name === params.booking_type ||
          el.name === decodeURIComponent(params.booking_type)
        ) {
          booking_type = {
            value: el.name,
            label: `${el.name} (${el.duration} minuti)`,
          };
        }
      }
    }

    setPrenotazioneObj({
      ...prenotazioneObj,
      booking_schema: schema,
      booking_type: booking_type,
      booking_fields: default_fields,
    });
  }, [params.booking_type, bookableTypes, schema]);

  function objectToQueryString(obj) {
    const queryString = [];
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(obj[key]);
        queryString.push(`${encodedKey}=${encodedValue}`);
      }
    }
    return queryString.join('&');
  }

  /* Select type change */
  const handleChangeMotivation = (selectedOption) => {
    const { pathname } = location;
    setPrenotazioneObj({
      ...prenotazioneObj,
      booking_type: selectedOption,
    });
    history.push(
      `${pathname}?${objectToQueryString({
        ...params,
        booking_type: selectedOption.value,
      })}`,
    );
  };

  /* check if input fields are required and populated */
  const checkRequiredValue = () => {
    const requiredAdditionalFields = (
      currentBookingType?.booking_additional_fields_schema || []
    ).filter((f) => f.required);
    for (const field of requiredAdditionalFields) {
      if (field.type === 'text' && !getFieldValue(field.name)) {
        return true;
      }
    }
    return (
      !prenotazioneObj.booking_type ||
      !prenotazioneObj.booking_fields?.filter(
        (s) => s.name === 'description',
      )?.[0]?.value
    );
  };

  const changeField = (name, value) => {
    // XXX: There is an hack to save additional fields, evaluate if it's possible to remove it
    //      and move the logic to the backend
    const additionalFieldsIds = (
      currentBookingType?.booking_additional_fields_schema || []
    ).map((f) => f.name);
    if (additionalFieldsIds.includes(name)) {
      setPrenotazioneObj({
        ...prenotazioneObj,
        additional_fields: changeBookingField(
          prenotazioneObj.additional_fields,
          name,
          value,
        ),
      });
    } else {
      setPrenotazioneObj({
        ...prenotazioneObj,
        booking_fields: changeBookingField(
          prenotazioneObj.booking_fields,
          name,
          value,
        ),
      });
    }
  };
  const getFieldValue = (field) => {
    // XXX: There is an hack to save additional fields, evaluate if it's possible to remove it
    //      and move the logic to the backend
    const additionalFieldsIds = (
      currentBookingType?.booking_additional_fields_schema || []
    ).map((f) => f.name);
    if (additionalFieldsIds.includes(field)) {
      return (
        prenotazioneObj?.additional_fields?.filter((f) => f.name === field)?.[0]
          ?.value ?? ''
      );
    }
    return (
      prenotazioneObj.booking_fields?.filter((f) => f.name === field)?.[0]
        ?.value ?? ''
    );
  };

  return (
    <>
      {/* MENU LATERALE */}
      <aside aria-hidden={true} className="col-12 col-lg-3">
        {__CLIENT__ && (
          <SideMenu
            data={sideMenuElements}
            content_uid={'prenotazioneDettagli'}
          />
        )}
      </aside>
      <section
        id="main-content-section"
        className="prenotazioneDettagli section-form col-12 col-lg-8 offset-lg-1 mt-3"
        ref={documentBody}
      >
        <RichTextSection
          title={intl.formatMessage(messages.motivation_title)}
          tag_id="prenotazioneDettagli_section_motivation"
          show_title={false}
        >
          <Card className="section-form--card mb-0 no-after">
            {/* SELECT TIPOLOGIA APPUNTAMENTO */}
            <h2 className="mb-0" aria-hidden={true}>
              {intl.formatMessage(messages.motivation_title) + '*'}
            </h2>
            <p className="mb-3">
              {intl.formatMessage(messages.motivation_description)}
            </p>
            <label htmlFor="booking-type" className="visually-hidden">
              {intl.formatMessage(messages.type_select_label)}
            </label>
            <SelectInput
              id="booking-type"
              placeholder={intl.formatMessage(messages.type_select_label)}
              aria-label={intl.formatMessage(messages.type_select_label)}
              value={prenotazioneObj.booking_type}
              options={getBookableTypesOptions(bookableTypes)}
              onChange={handleChangeMotivation}
            />
          </Card>
        </RichTextSection>

        <RichTextSection
          title={intl.formatMessage(messages.details_title)}
          tag_id="prenotazioneDettagli_section_description"
          show_title={false}
        >
          {/* DETTAGLI TEXTAREA */}
          <Card className="section-form--card mb-0 no-after">
            <h2 className="mb-0">
              {intl.formatMessage(messages.details_title)}*
            </h2>

            <p className="subtitle-small mb-3">
              {richTextHasContent(
                currentBookingType?.booking_details_help_text,
              ) ? (
                <RichText data={currentBookingType.booking_details_help_text} />
              ) : (
                intl.formatMessage(messages.details_description)
              )}
            </p>

            <label htmlFor="form-details" className="visually-hidden">
              {intl.formatMessage(messages.details_description)}
            </label>
            <TextArea
              id="form-details"
              className="border-top-0 border-end-0 border-start-0"
              rows={2}
              value={getFieldValue('description')}
              required={true}
              infoText={intl.formatMessage(messages.details_info_text)}
              onChange={(e) => changeField('description', e.target.value)}
            />

            {currentBookingType?.booking_additional_fields_schema &&
              currentBookingType.booking_additional_fields_schema.map(
                (field) =>
                  field.type === 'text' && (
                    <Input
                      key={field.name}
                      type={field.type}
                      label={field.required ? field.label + '*' : field.label}
                      aria-label={
                        field.required ? field.label + '*' : field.label
                      }
                      name={field.name}
                      value={getFieldValue(field.name)}
                      required={field.required}
                      infoText={field.description}
                      onChange={(e) => changeField(field.name, e.target.value)}
                    />
                  ),
              )}
          </Card>
        </RichTextSection>
      </section>

      {/* BUTTONS */}
      <PrenotazioneStepperActions
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        disabled={checkRequiredValue()}
        scrollToTop={scrollToTop}
      />
    </>
  );
};

export default PrenotazioneDettagli;
